import React from 'react';
import CreateAirlineWizard from './CreateAirlineWizard.jsx';

export default function Start() {
  return <CreateAirlineWizard />;
}